/* ============
 * Create Page
 * ============
 *
 * This is the page for adding recipes.
 */
import { mapGetters } from 'vuex';
import recipeService from './../../../../services/recipe';
import recipeTypeService from './../../../../services/recipeType';
import recipeTransformer from './../../../../transformers/recipe';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        notes: {
          value: '',
          type: 'textarea',
        },
        recipeTypeId: {
          value: '',
          type: 'select',
        },
      }),
    };
  },

  created() {
    Promise.all([
      recipeService.all(),
      recipeTypeService.all(),
    ]).then(() => {
      this.loading = false;
    });
  },

  computed: {
    ...mapGetters({
      recipeTypes: 'allRecipeTypes',
    }),
  },

  methods: {
    /**
     * Method to store the product group.
     */
    store() {
      this.form.loading = true;
      const recipe = recipeTransformer.send(this.form.data());
      recipeService.store(recipe)
        .then((response) => {
          this.form.loading = false;
          this.$message({
            message: this.$t('static.recipes.create.success'),
            type: 'success',
          });
          console.log(response);
          this.$router.push({
            name: 'production.recipes.edit',
            params: {
              id: response.id,
            },
          });
        }).catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
    },
    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },

  watch: {
    recipeTypes(types) {
      this.form.setOptions('recipeTypeId', types.map(c => ({
        id: c.id,
        name: this.$t(`static.recipes.types.${this.camalize(c.name)}`),
      })));
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/recipes/create/create.js